module.exports = __webpack_public_path__ + "assets/img/injection_icon.9609b25e.svg";